const e = {
  name: "Recurring",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,20c0-9.9,8.1-18,18-18c5.7,0,10.7,2.6,14,6.7l0,0c0.3,0.4,0.7,0.9,1,1.3h-9v2h12V0h-2v8
			c-0.1-0.2-0.3-0.4-0.4-0.6C31.9,2.9,26.3,0,20,0C9,0,0,9,0,20H2z"/>
		<path class="st0" d="M14,28H2v12h2v-8c0.1,0.2,0.3,0.4,0.4,0.6C8.1,37.1,13.7,40,20,40c11,0,20-9,20-20h-2c0,9.9-8.1,18-18,18
			c-5.7,0-10.7-2.6-14-6.7l0,0c-0.3-0.4-0.7-0.9-1-1.3h9V28z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Recurring
};
